import { render, staticRenderFns } from "./Fourth.vue?vue&type=template&id=735a0bbe&scoped=true&"
import script from "./Fourth.vue?vue&type=script&lang=js&"
export * from "./Fourth.vue?vue&type=script&lang=js&"
import style0 from "./Fourth.vue?vue&type=style&index=0&id=735a0bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735a0bbe",
  null
  
)

export default component.exports